import { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from './Icon.jsx';
import { Avatar } from './Avatar.jsx';
import { featureRoutes } from '../app/router.jsx';
import { useAuth } from '../shared/useAuth.js';
import { NotificationBell } from '../features/notifications/NotificationBell.jsx';
import { ShiftBadge } from '../features/shifts/components/ShiftBadge.jsx';
import { GlobalSearch } from '../features/search/GlobalSearch.jsx';

// الجزء الثابت من مسار المسار المُعرَّف: `/checkout/:sessionId?` → `/checkout`.
// بدونه كانت الشاشات ذات المعرّف في الرابط تفقد عنوانها في الشريط العلوي.
function staticPrefix(path) {
  return path.split('/:')[0].split('/*')[0] || path;
}

function findRoute(pathname) {
  const exact = featureRoutes.find((r) => r.path === pathname);
  if (exact) return exact;
  return featureRoutes.find((r) => {
    const prefix = staticPrefix(r.path);
    return prefix !== '/' && (pathname === prefix || pathname.startsWith(`${prefix}/`));
  });
}

const groupLabels = {
  main: 'الرئيسية',
  operations: 'التشغيل',
  sales: 'المبيعات',
  inventory: 'المخزون',
  finance: 'المالية',
  admin: 'الإدارة'
};

export function Topbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const route = findRoute(location.pathname);
  const title = route?.sidebar?.label || 'Kids Zone';
  const crumb = groupLabels[route?.sidebar?.group] || 'الرئيسية';

  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);

  const [openUser, setOpenUser] = useState(false);
  const userRef = useRef(null);

  useEffect(() => {
    function onClick(e) {
      if (userRef.current && !userRef.current.contains(e.target)) setOpenUser(false);
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const onLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="sticky top-0 z-10 flex items-center gap-3.5 px-7 py-4 bg-paper border-b border-line">
      <div>
        <div className="text-xs text-ink-3">{crumb}</div>
        <h1 className="text-xl font-bold tracking-tight m-0">{title}</h1>
      </div>
      <div className="flex-1" />

      <GlobalSearch />

      <ShiftBadge />

      <NotificationBell />

      {user ? (
        <div className="relative" ref={userRef}>
          <button
            type="button"
            className="flex items-center gap-2 px-2 py-1 rounded-[10px] bg-white border border-line shadow-card hover:bg-paper-2"
            onClick={() => setOpenUser((v) => !v)}
          >
            <Avatar size="sm" name={user.fullName || user.username} id={user.id} />
            <div className="text-right hidden md:block">
              <div className="text-[12.5px] font-semibold leading-tight">
                {user.fullName || user.username}
              </div>
              <div className="text-[10.5px] text-ink-3">{user.roleName || 'مستخدم'}</div>
            </div>
            <Icon name="chevronD" size={14} />
          </button>
          {openUser ? (
            <div className="absolute top-[46px] left-0 w-[200px] card p-1 z-20">
              <button
                type="button"
                onClick={onLogout}
                className="w-full flex items-center gap-2 px-3 py-2 rounded-[8px] hover:bg-paper-2 text-[13px] text-right"
              >
                <Icon name="logout" size={15} />
                تسجيل خروج
              </button>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
